import { render, staticRenderFns } from "./NotificationsView.vue?vue&type=template&id=070d2e65&"
import script from "./NotificationsView.vue?vue&type=script&lang=js&"
export * from "./NotificationsView.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports